module.exports = __webpack_public_path__ + "img/logo-secondary.3ab314a2.png";